<header class="binaryscroll"></header>
<div class="container">
  <!-- intro -->
  <div class="intro">
    <!-- info -->
    <!--<h1 class="mb-2 mt-0">Davide Gena</h1>-->
    <h1>
      <span class="signature-wrap">
        <span class="signature mb-0 mt-0" role="img" aria-label="Davide Gena"></span>
        <span class="sig-bubbles spot-left c-dark">
          <span class="bubble b1"></span>
          <span class="bubble b2"></span>
          <span class="bubble b3"></span>
        </span>
        <span class="sig-bubbles spot-mid c-dark">
          <span class="bubble b1"></span>
          <span class="bubble b2"></span>
          <span class="bubble b3"></span>
        </span>
        <span class="sig-bubbles spot-right c-dark">
          <span class="bubble b1"></span>
          <span class="bubble b2"></span>
          <span class="bubble b3"></span>
        </span>
      </span>
    </h1>
    <span>
      <span class="text-rotating">{{ typedText }}</span>
    </span>

    <!-- social icons -->
    <ul class="social-icons list-inline mb-0 mt-4">
      <li class="list-inline-item"><a href="https://www.instagram.com/davide.gena/"><i class="fab fa-instagram"></i></a></li>
      <li class="list-inline-item"><a href="https://www.linkedin.com/in/davide-gena/"><i class="fab fa-linkedin"></i></a></li>
      <li class="list-inline-item"><a href="https://github.com/davidegena"><i class="fab fa-github"></i></a></li>
    </ul>

    <!-- buttons -->
    <div class="mt-4">
      <a href="javascript:" class="btn btn-default" (click)="scrollTo('contact')">Contact me</a>
    </div>
  </div>

  <!-- scroll down mouse wheel -->
  <div class="scroll-down">
    <a href="javascript:" class="mouse-wrapper" (click)="scrollTo('about')">
      <span>Scroll Down</span>
      <span class="mouse">
        <span class="wheel"></span>
      </span>
    </a>
  </div>

  <!-- parallax layers -->
  <div id="scene" class="parallax" data-relative-input="true">
    <span data-depth="0.3" class="layer p1 icon-wrap c-yellow">
      <span class="icon-glow-wrap"><span class="icon-glow icon-atom"></span></span>
      <span class="icon-shape icon-atom"></span>
    </span>

    <span data-depth="0.2" class="layer p2 icon-wrap c-pink">
      <span class="icon-glow-wrap"><span class="icon-glow icon-bottle1"></span></span>
      <span class="icon-shape icon-bottle1"></span>
    </span>

    <span data-depth="0.3" class="layer p3 icon-wrap c-teal">
      <span class="icon-glow-wrap"><span class="icon-glow icon-microscop"></span></span>
      <span class="icon-shape icon-microscop"></span>
    </span>

    <span data-depth="0.6" class="layer p4 icon-wrap c-yellow">
      <span class="icon-glow-wrap"><span class="icon-glow icon-bottle2"></span></span>
      <span class="icon-shape icon-bottle2"></span>
    </span>

    <span data-depth="0.2" class="layer p5 icon-wrap c-purple">
      <span class="icon-glow-wrap"><span class="icon-glow icon-bottle3"></span></span>
      <span class="icon-shape icon-bottle3"></span>
    </span>

    <span data-depth="0.5" class="layer p6 icon-wrap c-pink">
      <span class="icon-glow-wrap"><span class="icon-glow icon-atom"></span></span>
      <span class="icon-shape icon-atom"></span>
    </span>

    <span data-depth="0.4" class="layer p7 icon-wrap c-yellow">
      <span class="icon-glow-wrap"><span class="icon-glow icon-bottle1"></span></span>
      <span class="icon-shape icon-bottle1"></span>
    </span>

    <span data-depth="0.3" class="layer p8 icon-wrap c-purple">
      <span class="icon-glow-wrap"><span class="icon-glow icon-microscop"></span></span>
      <span class="icon-shape icon-microscop"></span>
    </span>

    <span data-depth="0.3" class="layer p9 icon-wrap c-teal">
      <span class="icon-glow-wrap"><span class="icon-glow icon-bottle2"></span></span>
      <span class="icon-shape icon-bottle2"></span>
    </span>

    <span data-depth="0.2" class="layer p10 icon-wrap c-teal">
      <span class="icon-glow-wrap"><span class="icon-glow icon-bottle3"></span></span>
      <span class="icon-shape icon-bottle3"></span>
    </span>

    <span data-depth="0.5" class="layer p11 icon-wrap c-yellow">
      <span class="icon-glow-wrap"><span class="icon-glow icon-atom"></span></span>
      <span class="icon-shape icon-atom"></span>
    </span>
  </div>
</div>
